import React, { useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import { Modal } from '@material-ui/core'
import StackedBarChart from './StackedBarChart'
import SubscribersList from './SubscribersList'
import FlagsList from './flagsList'
import { getModalStyle } from './helpers'
import { tabs } from './constants'
import PersonAvatar from '../PersonAvatar'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '1rem 0',
  },
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  avatarStyle: {
    margin: '1rem 0.5rem 1rem 0rem',
    width: '20px',
    height: '20px',
    fontSize: '13px',
  },
  avatarWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  infoTextStyle: {
    cursor: 'pointer',
    fontWeight: '400',
    marginLeft: '.5rem',
  },
  textWrapper: {
    color: 'grey',
    fontSize: '12px',
  },
  linkedNameStyle: {
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  customStyleForUsersList: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: '1rem',
  },
}))

const MetricsContent = ({
  title,
  description,
  subTitles,
  flagSubTitles,
  tabDetail,
  subscribersCount,
  emptyMessage,
  catchedError,
  listForStackedBarChart,
  firstSubscriber,
  currentSubscribersCount,
  customStyles,
  optional,
  titleIcon,
  tabTitles,
  showOtherSubscriberList = false,
  otherFirstSubscriber,
  otherCurrentSubscribersCount,
  otherSubTitles,
  otherTabDetail,
  titleDescription,
}) => {
  const classes = useStyles()
  const [modalStyle] = React.useState(getModalStyle)
  const [openModal, setOpenModal] = React.useState(false)
  const [openSubscribersDetail, setOpenSubscribersDetail] = useState(false)
  const [subscriberDetailTitle, setSubscriberDetailTitle] = useState(subTitles)

  const toggleSubscribersDetail = () =>
    setOpenSubscribersDetail(!openSubscribersDetail)
  const [subscriberData, setSubscriberData] = useState()
  const handleOpenSubscribersDetail = (value) => {
    setSubscriberData(value)
    setOpenSubscribersDetail(true)
  }

  const toggleModal = (subTitles) => {
    setSubscriberDetailTitle(subTitles)
    setOpenModal(!openModal)
  }

  const renderAvatar = (
    firstSubscriber,
    currentSubscribersCount,
    subTitles,
  ) => {
    return (
      <div className={classes.avatarWrapper}>
        <PersonAvatar
          placeHolder={firstSubscriber && firstSubscriber.avatarCharacters}
          subId={firstSubscriber && firstSubscriber.id}
          alt={firstSubscriber && firstSubscriber.firstName}
          src={firstSubscriber && firstSubscriber.profilePicture}
          className={classes.avatarStyle}
        />
        <span className={classes.textWrapper}>
          {currentSubscribersCount > 1 ? (
            firstSubscriber && firstSubscriber.firstName
          ) : (
            <span
              onClick={() => {
                toggleModal(subTitles)
              }}
              className={classes.linkedNameStyle}
            >
              {firstSubscriber && firstSubscriber.firstName}
            </span>
          )}
          {currentSubscribersCount > 1 && (
            <span
              onClick={() => {
                toggleModal(subTitles)
              }}
              className={classes.infoTextStyle}
            >
              {
                <FormattedMessage
                  id="metrics.other"
                  values={{
                    count: currentSubscribersCount - 1,
                    u: (text) => (
                      <b>
                        <u>{text}</u>
                      </b>
                    ),
                  }}
                />
              }
            </span>
          )}
        </span>
      </div>
    )
  }

  return (
    <div className={classes.root} style={customStyles}>
      {listForStackedBarChart && (
        <StackedBarChart
          title={title}
          description={description}
          data={listForStackedBarChart}
          headerStyle={classes.headerStyle}
          descriptionStyle={classes.descriptionStyle}
          emptyMessage={emptyMessage}
          catchedError={catchedError}
          optional={optional}
          titleIcon={titleIcon}
          titleDescription={titleDescription}
        />
      )}
      {tabDetail ? (
        <div className="list-subscribers">
          <div className="flex justify-between">
            <div>
              {currentSubscribersCount > 0 &&
                renderAvatar(
                  firstSubscriber,
                  currentSubscribersCount,
                  subTitles,
                  tabDetail,
                )}
            </div>
            <div>
              {showOtherSubscriberList &&
                renderAvatar(
                  otherFirstSubscriber,
                  otherCurrentSubscribersCount,
                  otherSubTitles,
                  otherTabDetail,
                )}
            </div>
          </div>
          <Modal
            open={openModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <>
              {flagSubTitles ? (
                <FlagsList
                  style={modalStyle}
                  className={classes.paper}
                  openModal={openModal}
                  openSubscribersDetail={openSubscribersDetail}
                  onClose={toggleModal}
                  title={tabs['MarkedAsInappropriate']}
                  flagSubTitles={flagSubTitles}
                  tabDetail={tabDetail}
                  subscribersCount={subscribersCount}
                  customStyleForUsersList={
                    flagSubTitles && classes.customStyleForUsersList
                  }
                  handleOpenSubscribersDetail={handleOpenSubscribersDetail}
                  subscriberData={subscriberData}
                  handleCloseSubscribersDetail={toggleSubscribersDetail}
                />
              ) : (
                <SubscribersList
                  style={modalStyle}
                  className={classes.paper}
                  openModal={openModal}
                  openSubscribersDetail={openSubscribersDetail}
                  onClose={toggleModal}
                  title={title}
                  subTitles={subscriberDetailTitle}
                  flagSubTitles={flagSubTitles}
                  tabDetail={tabDetail}
                  subscribersCount={subscribersCount}
                  handleOpenSubscribersDetail={handleOpenSubscribersDetail}
                  subscriberData={subscriberData}
                  handleCloseSubscribersDetail={toggleSubscribersDetail}
                  tabTitles={tabTitles}
                />
              )}
            </>
          </Modal>
        </div>
      ) : null}
    </div>
  )
}

export default MetricsContent
